import styles from './YoutubeVideo.module.scss';

interface Props {
    id: string;
    chat?: boolean;
    autoPlay?: boolean;
}

export function YoutubeVideo({ id, chat, autoPlay }: Props) {
    return (
        <>
            <div className={styles.wrapper}>
                <iframe
                    title="YouTube Video"
                    id="ytplayer"
                    className={styles.iframe}
                    src={`https://www.youtube.com/embed/${id}?origin=https://www.prezly.com${autoPlay ? `&autoplay=1` : undefined}&rel=0`}
                    frameBorder="0"
                    allowFullScreen
                    allow={autoPlay ? 'autoplay' : undefined}
                />
            </div>

            {chat === true && (
                <div className={styles.wrapper}>
                    <iframe
                        title="YouTube Live Chat"
                        className={styles.iframe}
                        src={`https://www.youtube.com/live_chat?v=${id}&embed_domain=www.prezly.com`}
                        frameBorder="1"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    />
                </div>
            )}
        </>
    );
}
